import React, { useRef, useEffect, useState, createContext } from "react";
import { useLocation, Switch, Redirect, useParams } from "react-router-dom";
import AppRoute from "./utils/AppRoute";
import ScrollReveal from "./utils/ScrollReveal";
import ReactGA from "react-ga";
import axios from "axios";
import * as QueryString from "query-string";

// Layouts
import LayoutDefault from "./layouts/LayoutDefault";

// Views
import Home from "./views/Home";

import { Helmet, HelmetProvider } from "react-helmet-async";

const trackPage = (page) => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

const ProjectContext = React.createContext({});

const api_url =
  window.location.hostname !== "localhost"
    ? "https://new-api.copysmith.ai/"
    : "http://localhost:4000/";

const combineURL = (endpoint) => `${api_url}${endpoint}`;

const getProject = (documentId, workspaceId) => {
  return axios.get(combineURL(`documents/shared/${workspaceId}/${documentId}`));
};

const App = ({ ...props }) => {
  const childRef = useRef();
  let location = useLocation();

  const query = QueryString.parse(location.search);
  const { document: documentId, workspace: workspaceId } = query;
  const [generation, setGeneration] = useState(null);
  const [invalidLink, setInvalidLink] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getProject(documentId, workspaceId);
      setGeneration(result?.data);
    };
    fetchData();
  }, [documentId, workspaceId]);

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add("is-loaded");
    childRef.current.init();
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>Copysmtih Landing Page</title>
      </Helmet>
      {invalidLink && <Redirect to="/404"></Redirect>}
      <ProjectContext.Provider value={generation}>
        <ScrollReveal
          ref={childRef}
          children={() => (
            <Switch>
              <AppRoute
                path="/preview"
                component={Home}
                layout={LayoutDefault}
                props={props}
              />
            </Switch>
          )}
        />
      </ProjectContext.Provider>
    </HelmetProvider>
  );
};

export { ProjectContext };

export default App;
